import {Component, OnInit, ViewChild} from '@angular/core';
import {IndustriepartnerHttpService} from '../core/services/industriepartner-http.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {FormControl} from '@angular/forms';
import {LocalSearchService} from '../core/services/local-search.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-industriepartner',
  templateUrl: './industriepartner.component.html',
  styleUrls: ['./industriepartner.component.scss']
})
export class IndustriepartnerComponent implements OnInit {

  public loading = false;
  public industriepartner = new MatTableDataSource<Object>();
  public industriepartnerFiltered = new MatTableDataSource<Object>();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  public search = new FormControl();

  constructor(public industriepartnerService: IndustriepartnerHttpService, private router: Router) {
    this.search.valueChanges.subscribe(val => {
      this.industriepartnerFiltered.data = LocalSearchService.search(this.industriepartner.data, val);
    });
  }

  ngOnInit() {
    this.loading = true;
    this.industriepartnerService.getAllIndustriepartner().subscribe(res => {
      this.industriepartnerFiltered.paginator = this.paginator;
      this.industriepartnerFiltered.sort = this.sort;
      this.industriepartner.data = res as [];
      this.industriepartnerFiltered.data = res as [];
      this.loading = false;
    }, err => {
      console.log(err);
      this.loading = false;
      if(err.status == 403) {
        this.router.navigateByUrl('/');
      }
    });

  }
}
